import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"

import { Feedback } from "../../../../../components/Validator"

const defaultRangeId = "defaultTextRangeProperty"

// tslint:disable:no-empty-interface
interface ConfigureTextProps {
  default?: string
  valid: Feedback
  disabled: boolean
  setDisabled: (value: boolean) => void
  onUpdate: () => void
  setDefault: (id: string, e: any, valueType?: "Number" | "Decimal") => void
}

const ConfigureText = (props: ConfigureTextProps) => {
  const disabledDefault =
    props.disabled || (!props.valid.valid && props.valid.id !== defaultRangeId)

  const inValidDefault = props.valid.id === defaultRangeId

  const setDefault = (e: any) => props.setDefault(defaultRangeId, e)

  return (
    <Form>
      <Form.Group as={Row} controlId={defaultRangeId}>
        <Form.Label column={true} md="3">
          Default
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="text"
            value={props.default || ""}
            onChange={setDefault}
            onBlur={props.onUpdate}
            disabled={disabledDefault}
            isInvalid={inValidDefault}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional default value. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>
    </Form>
  )
}

export default ConfigureText
